import React, { Fragment } from "react"
import PropTypes from "prop-types"

import image from "shared/images/package-icon.png"

import styles from "./NoParcel.css"

const NoParcel = ({ trackingNumber }) => (
  <Fragment>
    <div className={[styles.root, "notfound"].join(" ")}>
      <div className="row">
        <div className="col-xs-3 textCenter">
          <img src={image} className="m-t-15 m-b-15" alt="Parcel not found" />
        </div>
        <div className="col-xs-9">
          {trackingNumber ? (
            <h1 className={styles.title}>No tracking information for this parcel (&nbsp;<strong>{trackingNumber}</strong>&nbsp;) has been found</h1>
          ) : (
            <h1 className={styles.title}>Oops an error occured</h1>
          )}
          <div className="hidden-xs">
            <Details />
          </div>
        </div>
      </div>
    </div>
    <div className="visible-xs">
      <Details />
    </div>
  </Fragment>
)

const Details = () => (
  <Fragment>
    <span className="textUnderlined">The reasons can be:</span>
    <ul>
      <li>The number you have entered is incorrect</li>
      <li>The number of the consignment letter has not been entered into the IT system, yet - please try entering the parcel number on the next day after posting an order in the morning hours.</li>
    </ul>
  </Fragment>
)

NoParcel.propTypes = {
  trackingNumber: PropTypes.string.isRequired,
}

export default NoParcel



// WEBPACK FOOTER //
// ./src/views/Parcel/components/NoParcel/NoParcel.js